module.exports = __webpack_public_path__ + "static/media/sliderHome1.1a216366.jpg";